export default function fetchPlansSuccess(state, payload) {
  const activePlans = payload.activePlans.map(plan => ({
    ...plan,
    editMode: !plan.notes,
  }));

  const completePlans = payload.completePlans.map(plan => ({
    ...plan,
    editMode: !plan.notes,
  }));

  return {
    ...state,
    activePlans,
    completePlans,
    isFetching: false,
    firstFetchHasOccurred: true,
  };
}